import { render } from "./TheProfessionalAnamnesis.vue?vue&type=template&id=c6a76fca&ts=true"
import script from "./TheProfessionalAnamnesis.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalAnamnesis.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__